export default {
  summary: (state) => state.summary,
  clients: (state) => state.clients,
  selected: (state) => state.selected,
  members: (state) => state.members,
  member: (state) => state.member,
  memberids: (state) => state.memberids,
  selectedids: (state) => state.selectedids,
  unselectedids: (state) => state.unselectedids,
  isAllChecked: (state) => state.isAllChecked,
  memberGoals: (state) => state.memberGoals,
  lists: (state) => state.lists,
  pager: (state) => state.pager,
  columns: (state) => state.columns,
  selectedView: (state) => state.selectedView,
  customViews: (state) => state.customViews,
  filter: (state) => state.filter,
  memberDailyProgress: (state) => state.memberDailyProgress,
  memberProfileHistory: (state) => state.memberProfileHistory,
  memberSessionHeartRates: (state) => state.memberSessionHeartRates,
  memberSession: (state) => state.memberSession,
  zoneProfile: (state) => state.zoneProfile,
  challengeStats: (state) => state.challengeStats,
}
